<template>
  <v-dialog v-model="open" scrollable max-width="500">
    <v-card v-if="timeslot_data">
      <v-card-title
        >{{ $t("pre_regis_add_subject.subject_id") }} :
        {{ subject_data.subject_id }}</v-card-title
      >
      <v-divider></v-divider>
      <v-card-text>
        <h1 class="mt-3 deep-orange--text">
          {{ subject_data.subject_name_th }}
        </h1>
        <h2 class="brown--text">
          {{ subject_data.subject_name_en }}
        </h2>
        <h2 class="mt-2 mb-2">
          {{ $t("pre_regis_add_subject.section") }} :
          {{ section }}
        </h2>
        <div
          v-for="(timeslot_data, index) in timeslot_data"
          :key="index"
          class="text-center"
        >
          {{
            dayjs(timeslot_data.START_DATE_TIME, "YYYY-MM-DD HH:mm:ss")
              .locale(lang)
              .format(`dddd D MMMM ${lang == "th" ? "BBBB" : "YYYY"} HH:mm`)
          }}
          -
          {{
            dayjs(timeslot_data.END_DATE_TIME, "YYYY-MM-DD HH:mm:ss")
              .locale(lang)
              .format("HH:mm")
          }}
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="open = false">
          {{ $t("pre_regis_add_subject.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as dayjs from "dayjs";
require("dayjs/locale/th");
import genericProvider from "@/services/generic.provider.js";
const genericService = new genericProvider();
import configTeachTableProvider from "@/services/config_teach_table.provider.js";
const configTeachTableService = new configTeachTableProvider();

export default {
  name: "TimeslotDialog",
  props: {
    levelId: {
      type: [String, Number],
      default: 1,
    },
  },
  data: () => ({
    open: false,
    subject_data: null,
    timeslot_data: null,
    section: null,
  }),
  computed: {
    lang() {
      if (this.$root.$i18n.locale) return this.$root.$i18n.locale;
      return "th";
    },
  },
  methods: {
    dayjs,
    lect_prac_lang(data) {
      if (this.$root.$i18n.locale === "en") {
        if (data === "ท") return "L";
        else return "P";
      }
      return data;
    },

    async fetch_subject(subject_id) {
      try {
        const data = await genericService.getRegistrarSubject(
          this.levelId,
          subject_id
        );
        if (data[0] && this.subject_data.subject_id === subject_id) {
          this.subject_data = data[0];
        }
      } catch {
        // Subject metadata is optional; the timetable dates remain viewable.
      }
    },

    async fetch_timeslot(teach_table_id) {
      const data = await configTeachTableService.getTimeSlot({
        level_id: this.levelId,
        teach_table_id: teach_table_id,
      });
      if (data["all_time_slot"]) {
        this.timeslot_data = data["all_time_slot"];
      }
    },

    show_item_detail(subject_id, teach_table_id, section) {
      this.subject_data = {
        subject_id,
        subject_name_th: "",
        subject_name_en: "",
      };
      this.timeslot_data = null;
      this.fetch_subject(subject_id);
      this.fetch_timeslot(teach_table_id);
      this.section = section;
      this.open = true;
    },
  },
};
</script>

<style></style>
